<template>
  <validation-observer
    v-if="!isPending"
    ref="simpleRules"
  >
    <div>
      <!-- main variant input -->
      <label>Varian Utama</label>
      <b-form-row>
        <b-col md="4">
          <validation-provider
            #default="{ errors }"
            name="varian utama"
            rules="required"
          >
            <v-select
              v-model="attributes[0]"
              :options="variantTypes"
              :searchable="false"
              placeholder="Ketik atau Pilih Varian"
              class="mb-50"
            >
              <template #list-footer>
                <hr class="m-0">
                <li class="p-50">
                  <b-button
                    block
                    size="sm"
                    variant="outline-primary"
                    @click.prevent="$bvModal.show('modal-variant')"
                  >
                    + Buat Tipe Varian
                  </b-button>
                </li>
              </template>
            </v-select>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-col>

        <b-col
          v-if="attributes[0]"
          class="pl-2"
          md
        >
          <b-form-tags
            :value="values[0]"
            no-outer-focus
            class="p-0 border-0"
            @input="addMainVariant(newMainVariant)"
          >
            <template v-slot="{ addTag }">
              <b-input-group>
                <b-form-input
                  v-model="newMainVariant"
                  :placeholder="`Ketik ${attributes[0].toLowerCase()} lain yang kamu inginkan`"
                  class="form-control"
                  @keydown.enter="addTag(newMainVariant)"
                />
                <b-input-group-append>
                  <b-button
                    variant="outline-primary"
                    @click="addTag(newMainVariant)"
                  >
                    + Tambah
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </template>
          </b-form-tags>

          <div class="d-inline-block">
            <span
              v-for="(tag, index) in values[0]"
              :key="tag"
              role="button"
              class="badge b-form-tag d-inline-flex align-items-center mw-100 mt-50 mr-50 badge-secondary"
              @click="showVariantNameModal('main',tag,index)"
            >{{ tag }}<feather-icon
              icon="EditIcon"
              size="12"
              class="ml-50"
            /></span>
          </div>

          <hr v-if="values[0].length">

          <div
            v-if="values[0].length"
            class="mb-1"
          >
            <b-form-checkbox
              v-model="withImage"
              name="check-button"
              switch
              inline
            >
              Gunakan foto varian
            </b-form-checkbox>
          </div>

          <div v-if="withImage">
            <div class="d-flex flex-wrap content-image-variant">
              <div
                v-for="(tag, index) in values[0]"
                :key="`image-tag-${tag}-${index}`"
                class="mr-1 mb-1 d-inline-flex align-items-center"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="`varian ${tag}`"
                  rules="required"
                >
                  <form-image
                    :id="`v-image-${tag}`"
                    v-model="variantImages[index]"
                    :label="tag"
                    :index="index"
                    :state="errors.length > 0 ? false : null"
                    with-label-name
                    :label-name="tag"
                    :width="1080"
                    with-endpoin
                    @finish="onInputImage"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </div>
            </div>
          </div>
        </b-col>

        <b-col
          v-if="hasSubVariant && $store.state.auth.userData.role === 'admin'"
          cols="auto"
        >
          <b-button
            v-b-tooltip.hover.top="'Hapus Varian Utama'"
            variant="outline-danger"
            class="btn-icon"
            @click.prevent="deleteMainVariant"
          >
            <feather-icon
              icon="TrashIcon"
              size="16"
            />
          </b-button>
        </b-col>
      </b-form-row>
      <hr>
      <!-- <pre>{{ editedVariantName }}</pre> -->
      <!-- sub variant input -->
      <b-button
        v-if="!hasSubVariant"
        :disabled="!values[0].length"
        variant="outline-primary"
        size="sm"
        @click.prevent="openSubVariant"
      >
        + Tambah Sub Varian
      </b-button>
      <div v-if="hasSubVariant">
        <label>Sub Varian</label>
        <b-form-row>
          <b-col md="4">
            <v-select
              v-model="attributes[1]"
              :options="variantTypes"
              :searchable="false"
              placeholder="Pilih Varian"
              class="mb-50"
            >
              <template #list-footer>
                <hr class="m-0">
                <li class="p-50">
                  <b-button
                    block
                    size="sm"
                    variant="outline-primary"
                    @click.prevent="$bvModal.show('modal-variant')"
                  >
                    + Buat Tipe Varian
                  </b-button>
                </li>
              </template>
            </v-select>
          </b-col>
          <b-col
            v-if="attributes[1]"
            class="pl-2"
            md
          >
            <b-form-tags
              :value="values[1]"
              no-outer-focus
              class="p-0 border-0"
              @input="addSubVariant(newSubVariant)"
            >
              <template v-slot="{ addTag }">
                <b-input-group>
                  <b-form-input
                    v-model="newSubVariant"
                    :placeholder="`Ketik ${attributes[1].toLowerCase()} lain yang kamu inginkan`"
                    class="form-control"
                    @keydown.enter="addTag(newSubVariant)"
                  />
                  <b-input-group-append>
                    <b-button
                      variant="outline-primary"
                      @click="addTag(newSubVariant)"
                    >
                      + Tambah
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </template>
            </b-form-tags>
            <div class="d-inline-block">
              <span
                v-for="(tag, index) in values[1]"
                :key="tag"
                role="button"
                class="badge b-form-tag d-inline-flex align-items-center mw-100 mt-50 mr-50 badge-secondary"
                @click="showVariantNameModal('sub',tag,index)"
              >{{ tag }}<feather-icon
                icon="EditIcon"
                size="12"
                class="ml-50"
              /></span>
            </div>
          </b-col>

          <b-col
            v-if="$store.state.auth.userData.role === 'admin'"
            cols="auto"
          >
            <b-button
              v-b-tooltip.hover.top="'Hapus Sub Varian'"
              variant="outline-danger"
              class="btn-icon"
              @click.prevent="deleteSubVariant"
            >
              <feather-icon
                icon="TrashIcon"
                size="16"
              />
            </b-button>
          </b-col>
        </b-form-row>
      </div>
      <hr>
      <!-- variant table -->
      <div v-if="showTable">
        <b-row>
          <b-col cols="12">
            <div style="overflow-x: auto; width: 100%;">
              <b-table
                responsive
                small
                :items="variants.flat()"
                :fields="tableFields"
              >
                <template #head(image)>
                  <span
                    v-show="withImage"
                    class="pl-1"
                  />
                </template>
                <template #head(originalPrice)="scope">
                  <div class="text-nowrap pt-25 pb-50">
                    {{ scope.label }}
                  </div>

                  <div class="bulk-input">
                    <b-input-group
                      size="sm"
                      prepend="Rp"
                    >
                      <cleave
                        v-model="bulkOriginalPrice"
                        class="form-control"
                        :raw="true"
                        :disabled="bulkPriceDisabled"
                        :options="options.number"
                        @input="changeAllPrice"
                      />
                    </b-input-group>
                  </div>
                </template>
                <template #head(discountedPrice)="scope">
                  <div class="text-nowrap pt-25 pb-50">
                    {{ scope.label }}
                  </div>

                  <div class="bulk-input">
                    <b-input-group
                      size="sm"
                      prepend="Rp"
                    >
                      <cleave
                        v-model="bulkDiscountedPrice"
                        class="form-control"
                        :raw="true"
                        :disabled="bulkPriceDisabled"
                        :options="options.number"
                        @input="changeAllDiscountedPrice"
                      />
                    </b-input-group>
                  </div>
                </template>
                <template #head(stock)="scope">
                  <div class="text-nowrap pt-25 pb-50">
                    {{ scope.label }}
                  </div>

                  <div class="bulk-input">
                    <b-input-group
                      size="sm"
                    >
                      <cleave
                        v-model="stock"
                        class="form-control"
                        :raw="true"
                        :options="options.number"
                        @input="changeAllStock"
                      />
                    </b-input-group>
                  </div>
                </template>
                <template #head(weight)="scope">
                  <div class="text-nowrap pt-25 pb-50">
                    {{ scope.label }}
                  </div>

                  <div class="bulk-input">
                    <b-input-group
                      size="sm"
                    >
                      <cleave
                        v-model="weight"
                        class="form-control"
                        :raw="true"
                        :options="options.number"
                        @input="changeAllWeight"
                      />
                    </b-input-group>
                  </div>
                </template>
                <template #head(preorder_days)="scope">
                  <div class="text-nowrap pt-25 pb-50">
                    {{ scope.label }}
                  </div>

                  <div class="bulk-input">
                    <b-form-select
                      v-model="bulkPreorderDays"
                      size="sm"
                      :options="bulkPreorderOptions"
                      @change="changeAllPreorderDays"
                    />
                  </div>
                </template>
                <template #head()="scope">
                  <div class="text-nowrap pt-25 pb-50">
                    {{ scope.label }}
                  </div>
                </template>

                <!-- Column: Name -->
                <template #cell(image)="data">
                  <div
                    v-if="withImage"
                    class="pl-1"
                  >
                    <img
                      v-if="getVariantImageUrl(data.item)"
                      :src="getVariantImageUrl(data.item)"
                      alt="icon"
                      class="border rounded"
                      style="width: 36px; height: 36px; object-fit: cover;"
                    >
                    <div
                      v-else
                      class="border rounded"
                      style="width: 36px; height: 36px; background-color: rgba(140,140,140,0.1);"
                    />
                  </div>
                  <span
                    v-else
                    v-show="false"
                  />
                </template>
                <template #cell(variant)="data">
                  {{ data.item.details[0].value }}
                  <span v-if="attributes[1]"> - {{ data.item.details[1].value }}</span>
                </template>
                <!-- Column: Harga -->
                <template #cell(originalPrice)="data">
                  <validation-provider
                    #default="{ errors }"
                    :name="`harga${data.index}`"
                    rules="required"
                  >
                    <b-input-group
                      size="sm"
                      prepend="Rp"
                    >
                      <cleave
                        v-model="data.item.originalPrice"
                        class="form-control"
                        :class="{'is-invalid' : errors.length > 0}"
                        :disabled="!getVariantCanEditPrice(data.item)"
                        :raw="true"
                        :options="options.number"
                      />
                    </b-input-group>
                    <small
                      v-if="errors.length > 0"
                      class="text-danger"
                    >harus diisi.</small>
                  </validation-provider>
                </template>
                <!-- Column: Harga Diskon -->
                <template #cell(discountedPrice)="data">
                  <b-input-group
                    size="sm"
                    prepend="Rp"
                  >
                    <cleave
                      v-model="data.item.discountedPrice"
                      class="form-control"
                      :class="{'is-invalid' : data.item.discountedPrice && data.item.originalPrice && Number(data.item.discountedPrice) >= Number(data.item.originalPrice)}"
                      :disabled="!getVariantCanEditPrice(data.item)"
                      :raw="true"
                      :options="options.number"
                    />
                  </b-input-group>
                  <small
                    v-if="data.item.discountedPrice && data.item.originalPrice && Number(data.item.discountedPrice) >= Number(data.item.originalPrice)"
                    class="text-danger d-block mt-25"
                  >
                    Harga tidak sesuai
                  </small>
                </template>
                <!-- Column: Stok -->
                <template #cell(stock)="data">
                  <validation-provider
                    #default="{ errors }"
                    :name="`stok${data.index}`"
                    rules="required"
                  >
                    <cleave
                      v-model="data.item.stock"
                      class="form-control form-control-sm"
                      :class="{'is-invalid' : errors.length > 0}"
                      :raw="true"
                      :options="options.number"
                    />
                    <small
                      v-if="errors.length > 0"
                      class="text-danger"
                    >harus diisi.</small>
                  </validation-provider>
                </template>
                <!-- Column: Berat -->
                <template #cell(weight)="data">
                  <validation-provider
                    #default="{ errors }"
                    :name="`berat${data.index}`"
                    rules="required"
                  >
                    <cleave
                      v-model="data.item.weight"
                      class="form-control form-control-sm"
                      :raw="true"
                      :options="options.number"
                      :class="{'is-invalid' : errors.length > 0}"
                    />
                    <small
                      v-if="errors.length > 0"
                      class="text-danger"
                    >harus diisi.</small>
                  </validation-provider>
                </template>
                <!-- Column: Pre-Order -->
                <template #cell(preorder_days)="data">
                  <b-form-select
                    v-model="data.item.preorder_days"
                    size="sm"
                    :options="preorderOptions"
                  />
                </template>
                <template #cell(sku_name)="data">
                  <b-form-input
                    v-model="data.item.sku_name"
                    size="sm"
                  />
                </template>
                <!-- Column: Minimum Order -->
                <template #cell(minimum_order)="data">
                  <validation-provider
                    #default="{ errors }"
                    :name="`minorder${data.index}`"
                    rules="required"
                  >
                    <cleave
                      v-model="data.item.minimum_order"
                      class="form-control form-control-sm"
                      :class="{'is-invalid' : errors.length > 0}"
                      :raw="true"
                      :options="options.number"
                    />
                    <small
                      v-if="errors.length > 0"
                      class="text-danger"
                    >harus diisi.</small>
                  </validation-provider>
                </template>
              </b-table>
            </div>
          </b-col>
        </b-row>
        <hr>
      </div>
      <!-- Jangan hapus kode dibawah ini -->
      <pre class="d-none">{{ variants }}</pre>
      <!-- Jangan hapus kode diatas ini -->
      <!-- modal -->
      <b-modal
        id="modal-variant"
        title="Buat Tipe Varian"
      >
        <b-form-input
          ref="inputVariantType"
          placeholder="Masukkan varian"
          class="form-control"
        />
        <template #modal-footer="{ cancel }">
          <b-button
            variant="outline-secondary"
            @click="cancel()"
          >
            Batalkan
          </b-button>
          <b-button
            variant="primary"
            @click.prevent="addVariantType"
          >
            Simpan
          </b-button>
        </template>
      </b-modal>
      <!-- modal variant value -->
      <b-modal
        id="modal-variant-name"
        title="Edit Nama Varian"
      >
        <b-form-input
          ref="inputVariantName"
          :value="editedVariantName.tag"
          placeholder="Masukkan varian"
          class="form-control"
        />
        <template #modal-footer>
          <b-button
            variant="outline-danger"
            @click.prevent="deleteVariantName()"
          >
            Hapus Varian
          </b-button>
          <b-button
            variant="primary"
            @click.prevent="updateVatiantName()"
          >
            Simpan
          </b-button>
        </template>
      </b-modal>
    </div>
    <!-- <pre>{{ variants.flat() }}</pre> -->
  </validation-observer>
</template>

<script>
import {
  BFormRow,
  BRow,
  BCol,
  BTable,
  // BThead,
  // BTr,
  // BTh,
  BFormTags,
  BInputGroup,
  BInputGroupAppend,
  BFormInput,
  BButton,
  BModal,
  BFormCheckbox, VBTooltip,
  BFormSelect,
} from 'bootstrap-vue'

import Cleave from 'vue-cleave-component'
import vSelect from 'vue-select'
// Vee Validate
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import FormImage from '@/layouts/components/custom/FormImage.vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BFormRow,
    BRow,
    BCol,
    BFormTags,
    BTable,
    // BThead,
    // BTr,
    // BTh,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BModal,
    Cleave,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    BFormCheckbox,
    FormImage,
    BFormSelect,
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      default: () => ({}),
    },
    variantsData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      newMainVariant: '',
      newSubVariant: null,
      bulkOriginalPrice: '',
      bulkDiscountedPrice: '',
      stock: '',
      weight: '',
      bulkPreorderDays: '',
      bulkPreorderOptions: [
        { value: '', text: '-' },
        { value: null, text: 'In-stock' },
        { value: 7, text: '7 Hari' },
        { value: 14, text: '14 Hari' },
        { value: 21, text: '21 Hari' },
        { value: 28, text: '28 Hari' },
      ],
      preorderOptions: [
        { value: null, text: 'In-stock' },
        { value: 7, text: '7 Hari' },
        { value: 14, text: '14 Hari' },
        { value: 21, text: '21 Hari' },
        { value: 28, text: '28 Hari' },
      ],
      hasSubVariant: false,
      attributes: [], // variant label | ex. [color, size]
      values: [[], []], // variant value | ex. [[black,white], [s,m]]
      variantTypes: ['Warna', 'Motif', 'Ukuran', 'Kemasan'],
      variants: [],
      variantImages: [],
      variantImagesId: [],
      editedVariantName: {
        type: null,
        tag: null,
        index: null,
      },
      tableFields: [
        { key: 'image', tdClass: ['px-0'], thClass: ['px-0'] },
        { key: 'variant', tdClass: ['text-nowrap', 'align-top'], thClass: 'text-nowrap' },
        {
          key: 'originalPrice', label: 'Harga Awal', tdClass: 'align-top', thStyle: { minWidth: '140px' },
        },
        {
          key: 'discountedPrice', label: 'Harga Diskon', tdClass: 'align-top', thStyle: { minWidth: '140px' },
        },
        {
          key: 'stock', label: 'Stok', thStyle: { width: '80px', minWidth: '80px' }, tdClass: 'align-top',
        },
        {
          key: 'weight', label: 'Berat (gram)', tdClass: 'align-top', thStyle: { width: '115px', minWidth: '115px' },
        },
        {
          key: 'preorder_days', label: 'Pre-Order', tdClass: 'align-top', thStyle: { minWidth: '130px' },
        },
        {
          key: 'sku_name', label: 'SKU', tdClass: 'align-top', thStyle: { minWidth: '110px' },
        },
        // {
        //   key: 'minimum_order', label: 'Minimum Order', tdClass: 'align-top', thStyle: { width: '80px', minWidth: '80px' },
        // },
      ],
      options: {
        number: {
          numeral: true,
          numeralThousandsGroupStyle: 'thousand',
          numeralDecimalMark: ',',
          delimiter: '.',
          numeralPositiveOnly: true,
          numeralDecimalScale: 0,
        },
      },
      required,
      isPending: false,
      withImage: false,
    }
  },
  computed: {
    showTable() {
      if (!this.hasSubVariant) {
        if (this.values[0].length) {
          return true
        }
        return false
      } if (this.hasSubVariant) {
        if (this.values[1].length) {
          return true
        }
        return false
      }
      return false
    },
    variantTableName() {
      if (this.showTable) {
        if (this.hasSubVariant) {
          return `${this.attributes[0]} - ${this.attributes[1]}`
        }
        return `${this.attributes[0]}`
      }
      return ''
    },
    bulkPriceDisabled() {
      const hasEditableVariants = this.variants.flat().some(variant => this.getVariantCanEditPrice(variant))
      return !hasEditableVariants
    },
  },
  watch: {
    variants: {
      deep: true,
      handler() {
        const list = this.variants.flat()
        if (list.length > 0) {
          const allSame = list.every(val => val.preorder_days === list[0].preorder_days)
          this.bulkPreorderDays = allSame ? list[0].preorder_days : ''
        }
      },
    },
    attributes() {
      this.tableFields[1].label = this.variantTableName
    },
    showTable() {
      if (this.showTable) {
        this.tableFields[1].label = this.variantTableName
      }
    },
    variantsData: {
      handler(newVal) {
        if (newVal && newVal.length && !this.values[0].length) {
          this.initVariantData()
        }
      },
      deep: true,
    },
  },
  created() {
    this.initVariantData()
  },
  methods: {
    initVariantData() {
      if (this.isEdit && this.variantsData && this.variantsData.length) {
        this.isPending = true
        this.attributes = []
        this.values = [[], []]
        this.variants = []
        this.variantImages = []
        this.variantImagesId = []
        this.hasSubVariant = false
        this.withImage = false

        const listVariant = this.variantsData.map(el => el.details).flat().reduce((group, variant) => {
          const {
            label, value, image_url, image_id,
          } = variant
          // eslint-disable-next-line no-param-reassign
          group[label] = group[label] ?? []
          group[label].push({
            value,
            image_url,
            image_id,
          })
          // eslint-disable-next-line no-param-reassign
          group[label] = group[label].reduce((acc, current) => {
            const x = acc.find(item => item.value === current.value)
            if (!x) {
              return acc.concat([current])
            }
            if (!x.image_url && current.image_url) {
              x.image_url = current.image_url
              x.image_id = current.image_id
            }
            return acc
          }, [])
          return group
        }, {})

        const variantKeys = Object.keys(listVariant)
        if (!variantKeys.length) {
          this.isPending = false
          return
        }

        const defaultVariant = variantKeys[0]
        this.attributes[0] = defaultVariant
        listVariant[defaultVariant].forEach(el => {
          this.values[0].push(el.value)
        })

        // Check if any variant has image
        const hasAnyImage = listVariant[defaultVariant].some(el => !!el.image_url || !!el.image_id)
        if (hasAnyImage) {
          this.withImage = true
        }

        // init image variants
        this.variantImages = listVariant[defaultVariant].map(el => el.image_url || null)
        this.variantImagesId = listVariant[defaultVariant].map(el => el.image_id || null)

        if (variantKeys[1]) {
          this.hasSubVariant = true
          const subVariant = variantKeys[1]
          this.attributes[1] = subVariant
          listVariant[subVariant].forEach(el => {
            this.values[1].push(el.value)
          })
        }

        this.variants = []
        if (this.hasSubVariant) {
          listVariant[defaultVariant].forEach(mainEl => {
            const subList = []
            listVariant[this.attributes[1]].forEach(subEl => {
              const matchedVariant = this.variantsData.find(er => (
                er.details.some(ex => ex.label === defaultVariant && ex.value === mainEl.value)
                && er.details.some(ex => ex.label === this.attributes[1] && ex.value === subEl.value)
              ))
              if (matchedVariant) {
                subList.push({
                  ...matchedVariant,
                  preorder_days: matchedVariant.preorder_days !== undefined && matchedVariant.preorder_days !== null ? matchedVariant.preorder_days : null,
                })
              } else {
                subList.push(this.variantTemplate({ variant: mainEl.value, subvariant: subEl.value }))
              }
            })
            this.variants.push(subList)
          })
        } else {
          listVariant[defaultVariant].forEach(mainEl => {
            const matchedVariant = this.variantsData.find(er => er.details.some(ex => ex.label === defaultVariant && ex.value === mainEl.value))
            if (matchedVariant) {
              this.variants.push([{
                ...matchedVariant,
                preorder_days: matchedVariant.preorder_days !== undefined && matchedVariant.preorder_days !== null ? matchedVariant.preorder_days : null,
              }])
            } else {
              this.variants.push([this.variantTemplate({ variant: mainEl.value })])
            }
          })
        }

        this.isPending = false
      }
    },
    changeAllPrice() {
      this.variants.flat().forEach(variant => {
        if (this.getVariantCanEditPrice(variant)) {
          // eslint-disable-next-line no-param-reassign
          variant.originalPrice = this.bulkOriginalPrice
        }
      })
    },
    changeAllDiscountedPrice() {
      this.variants.flat().forEach(variant => {
        if (this.getVariantCanEditPrice(variant)) {
          // eslint-disable-next-line no-param-reassign
          variant.discountedPrice = this.bulkDiscountedPrice
        }
      })
    },
    changeAllStock() {
      this.variants.flat().forEach(variant => {
        // eslint-disable-next-line no-param-reassign
        variant.stock = this.stock
      })
    },
    changeAllWeight() {
      this.variants.flat().forEach(variant => {
        // eslint-disable-next-line no-param-reassign
        variant.weight = this.weight
      })
    },
    changeAllPreorderDays() {
      if (this.bulkPreorderDays === '') return
      this.variants.flat().forEach(variant => {
        // eslint-disable-next-line no-param-reassign
        variant.preorder_days = this.bulkPreorderDays
      })
    },
    addVariantType() {
      let variant = this.$refs.inputVariantType.$el.value
      if (variant) {
        if (!this.variantTypes.includes(variant.trim())) {
          this.variantTypes.push(variant.trim())
        }
        variant = ''
        this.$bvModal.hide('modal-variant')
      }
    },
    removeMainVariantValue(index) {
      this.values[0].splice(index, 1)
      this.variants.splice(index, 1)
      this.variantImages.splice(index, 1)
      this.variantImagesId.splice(index, 1)
    },
    async removeSubVariantValue(index) {
      this.values[1].splice(index, 1)

      if (!this.values[1].length) {
        this.hasSubVariant = false
        this.attributes[1] = ''
        this.values[1] = []
        this.variants = []
        this.values[0].forEach((item, mainIdx) => {
          const tpl = this.variantTemplate({ variant: item })
          if (this.withImage && this.variantImagesId[mainIdx]) {
            tpl.details[0].image_id = this.variantImagesId[mainIdx]
            tpl.details[0].image_url = this.variantImages[mainIdx]
          }
          this.variants.push([tpl])
        })
      } else {
        this.variants.forEach(item => {
          if (Array.isArray(item)) {
            item.splice(index, 1)
          }
        })
      }
    },
    openSubVariant() {
      this.hasSubVariant = true
      this.variants = []
      this.values[0].forEach(() => {
        this.variants.push([])
      })
    },
    addMainVariant(newVariant) {
      if (!newVariant || !newVariant.trim()) return
      const trimmed = newVariant.trim()
      if (this.values[0].includes(trimmed)) return

      this.values[0].push(trimmed)
      this.variantImages.push(null)
      this.variantImagesId.push(null)
      if (!this.hasSubVariant) {
        this.variants.push([this.variantTemplate({ variant: trimmed })])
      } else {
        const container = []
        this.values[1].forEach(subvariant => {
          container.push(this.variantTemplate({ variant: trimmed, subvariant }))
        })
        this.variants.push(container)
      }
      this.newMainVariant = ''
    },
    addSubVariant(newVariant) {
      if (!newVariant || !newVariant.trim()) return
      const trimmed = newVariant.trim()
      if (this.values[1].includes(trimmed)) return

      this.values[1].push(trimmed)
      this.values[0].forEach((item, index) => {
        if (Array.isArray(this.variants[index])) {
          this.variants[index].push(this.variantTemplate({ variant: item, subvariant: trimmed }))
        }
      })
      this.newSubVariant = ''
    },
    variantTemplate({
      variant, subvariant = null, imageId = null, imageUrl = null,
    }) {
      const details = []
      let imgId = imageId
      let imgUrl = imageUrl

      if (!imgId && this.withImage && this.values[0]) {
        const mainIdx = this.values[0].indexOf(variant)
        if (mainIdx !== -1) {
          imgId = this.variantImagesId[mainIdx] || null
          imgUrl = this.variantImages[mainIdx] || null
        }
      }

      details.push({
        label: this.attributes[0],
        value: variant,
        image_id: imgId,
        image_url: imgUrl,
      })
      if (subvariant) {
        details.push({
          label: this.attributes[1],
          value: subvariant,
          image_id: null,
        })
      }
      return {
        // variant: name,
        details,
        originalPrice: null,
        discountedPrice: null,
        stock: null,
        weight: null,
        sku_name: null,
        preorder_days: null,
        // minimum_order: 1,
        active: true,
        can_edit_price: true,
      }
    },
    removeAllVariant() {
      this.variants = []
      this.hasSubVariant = false
      this.withImage = false
      this.attributes = []
      this.values = [[], []]
      this.variantImages = []
      this.variantImagesId = []
    },
    async removeAllSubVariant() {
      this.variants = await []
      this.hasSubVariant = await false
      this.values = await [[], []]
      this.attributes[1] = ''
    },
    deleteMainVariant() {
      if (!this.hasSubVariant) {
        // If no sub variant exists, can't delete main variant
        return
      }

      // Promote sub variant to main variant
      this.attributes = [this.attributes[1]]
      this.values[0] = [...this.values[1]]

      // Clear sub variant data
      this.hasSubVariant = false
      this.attributes[1] = ''
      this.values[1] = []
      this.variantImages = this.values[0].map(() => null)
      this.variantImagesId = this.values[0].map(() => null)
      this.withImage = false

      // Repopulate variants with promoted sub variants as main variants
      this.variants = []
      this.values[0].forEach(promotedMainVariantValue => {
        this.variants.push([this.variantTemplate({ variant: promotedMainVariantValue })])
      })
    },
    deleteSubVariant() {
      // Clear sub variant data
      this.hasSubVariant = false
      this.attributes[1] = ''
      this.values[1] = []

      // Repopulate variants with only main variants
      this.variants = []
      this.values[0].forEach((mainVariantValue, index) => {
        const tpl = this.variantTemplate({ variant: mainVariantValue })
        if (this.withImage && this.variantImagesId[index]) {
          tpl.details[0].image_id = this.variantImagesId[index]
          tpl.details[0].image_url = this.variantImages[index]
        }
        this.variants.push([tpl])
      })
    },
    // NOTE submit
    async validationForm() {
      const response = await this.$refs.simpleRules.validate()
      // get variant (instead of sub-variant)
      const listVariant = {
        name: this.attributes[0],
        sku_attributes: this.values[0].map((el, index) => ({
          name: el,
          image_id: this.withImage ? (this.variantImagesId[index] || null) : null,
        })),
      }

      const variants = this.variants.flat()
      variants.forEach((item, index) => {
        item.details.forEach((itemDetails, detailIndex) => {
          const { label } = itemDetails

          // if this is variant (instead of sub-variant)
          if (label === listVariant.name) {
            const variant = listVariant.sku_attributes.find(el => el.name === itemDetails.value)
            variants[index].details[detailIndex].image_id = (this.withImage && variant) ? (variant.image_id || null) : null
          }
        })
      })

      this.$emit('updateVariants', variants)

      // Validation: Don't submit if there is Discount Price >= Normal Price
      const hasInvalidPrice = variants.some(item => item.discountedPrice && item.originalPrice && Number(item.discountedPrice) >= Number(item.originalPrice))
      if (hasInvalidPrice) {
        return false
      }

      return response
    },
    showVariantNameModal(type, tag, index) {
      this.$bvModal.show('modal-variant-name')
      this.editedVariantName = { type, tag, index }
    },
    deleteVariantName() {
      const { type, index } = this.editedVariantName
      if (type === 'main') {
        this.removeMainVariantValue(index)
      } else if (type === 'sub') {
        this.removeSubVariantValue(index)
      }
      this.$bvModal.hide('modal-variant-name')
    },
    updateVatiantName() {
      const { type, index } = this.editedVariantName
      const newName = this.$refs.inputVariantName.$el.value.trim()

      if (type === 'main') {
        if (newName) {
          this.$set(this.values[0], index, newName)
          this.updateMainVariant({ index, newName })
        }
      } else if (type === 'sub') {
        if (newName) {
          this.$set(this.values[1], index, newName)
          this.updateSubVariant({ index, newName })
        }
      }
      this.$bvModal.hide('modal-variant-name')
    },
    updateMainVariant({ index, newName }) {
      if (this.variants[index]) {
        if (Array.isArray(this.variants[index])) {
          this.variants[index].forEach((_, subIndex) => {
            if (this.variants[index][subIndex].details && this.variants[index][subIndex].details[0]) {
              this.variants[index][subIndex].details[0].value = newName
            }
          })
        } else if (this.variants[index].details && this.variants[index].details[0]) {
          this.variants[index].details[0].value = newName
        }
      }
    },
    updateSubVariant({ index, newName }) {
      this.variants.forEach((_, variantIndex) => {
        if (Array.isArray(this.variants[variantIndex]) && this.variants[variantIndex][index]) {
          if (this.variants[variantIndex][index].details && this.variants[variantIndex][index].details[1]) {
            this.variants[variantIndex][index].details[1].value = newName
          }
        }
      })
    },
    getVariantCanEditPrice(variant) {
      if (variant && variant.can_edit_price !== undefined) {
        return variant.can_edit_price
      }
      return true
    },
    async onInputImage(data, index) {
      const datas = typeof data === 'string' ? JSON.parse(data) : data
      this.$set(this.variantImagesId, index, datas.id)
      this.$set(this.variantImages, index, datas.image_url)

      const targetValue = this.values[0][index]
      this.variants.flat().forEach(variant => {
        if (variant.details && variant.details[0] && variant.details[0].value === targetValue) {
          // eslint-disable-next-line no-param-reassign
          variant.details[0].image_id = datas.id
          // eslint-disable-next-line no-param-reassign
          variant.details[0].image_url = datas.image_url
        }
      })
    },
    getVariantImageUrl(item) {
      if (item && item.details && item.details[0]) {
        if (item.details[0].image_url) {
          return item.details[0].image_url
        }
        if (this.withImage && this.values[0]) {
          const index = this.values[0].indexOf(item.details[0].value)
          if (index !== -1 && this.variantImages[index]) {
            return this.variantImages[index]
          }
        }
      }
      return null
    },
  },
}
</script>

<style lang="scss">
.content-image-variant {
    border: 1px solid #eee;
    padding: 1rem 0 0 1rem;
    border-radius: 8px;
}

.bulk-input * {
  background-color: rgba(255, 255, 255, 0%);
  transition: background-color 300ms;
}

.bulk-input:hover *,
.bulk-input:focus *,
.bulk-input:focus-within * {
  background-color: rgba(255, 255, 255, 100%);
}

.dark-layout {
  .bulk-input * {
    background-color: rgba(255, 255, 255, 0%);
  }
  .bulk-input:hover *,
  .bulk-input:focus *,
  .bulk-input:focus-within * {
    background-color: #283046 !important;
  }
}
</style>
